'use strict';

(function() {
	angular.module('onboarding.carrier')
		.directive('cobCarrierProfileLaneCoverage', cobCarrierProfileLaneCoverage);

	cobCarrierProfileLaneCoverage.$inject = [
		'$timeout', 'sessionService', 'subjectObserverMessagesService', 'observerService', 'carrierRegistrationService', '$stateParams'
	];

	var $timeout, sessionService, subjectObserverMessagesService, observerService, carrierRegistrationService, $stateParams;
	var subjectMessages, observerMessages, allMetros, ignoreAllUsToggle;

	function cobCarrierProfileLaneCoverage(_$timeout_,
		_sessionService_,
		_subjectObserverMessagesService_,
		_observerService_,
		_carrierRegistrationService_,
		_$stateParams_) {
		$timeout = _$timeout_;
		sessionService = _sessionService_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		carrierRegistrationService = _carrierRegistrationService_;
		$stateParams = _$stateParams_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/carrier/profile/carrierProfileLaneCoverage.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.carrierId = $stateParams.carrierId;

			scope.m = {
				isBroker: sessionService.isBroker(),
				isAdmin: sessionService.isAuthorizedInternalAdmin(),
				preferredLanes: [],
				preferredAreas: {},
				showNewLane: false,
				showCanadaMexico: false,
				showUnitedStates: false
			};

			scope.trashClick = trashClick;
			scope.saveLane = saveLane;
			scope.addClicK = addClicK;

			scope.setIsDirty = setIsDirty;
			scope.canadaMexicoClick = canadaMexicoClick;
			scope.allCanadianRegionsChange = allCanadianRegionsChange;
			scope.westernChange = westernChange;
			scope.centralChange = centralChange;
			scope.easternChange = easternChange;
			scope.provinceChange = provinceChange;
			scope.goToTab = goToTab;

			scope.unitedStatesClick = unitedStatesClick;
			scope.allUsCheckClick = allUsCheckClick;
			scope.allUsZoneChange = allUsZoneChange;
			scope.zone0Change = zone0Change;
			scope.zone1Change = zone1Change;
			scope.zone2Change = zone2Change;
			scope.zone3Change = zone3Change;
			scope.zone4Change = zone4Change;
			scope.zone5Change = zone5Change;
			scope.zone6Change = zone6Change;
			scope.zone7Change = zone7Change;
			scope.zone8Change = zone8Change;
			scope.zone9Change = zone9Change;
			scope.stateChange = stateChange;

			setAllMetros();
			loadData();
			registerObserverHandlers();
			document.title = 'Profile-Lanes';

			$timeout(function() {
				observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_LOAD);
			},
			100);
		}

		function setAllMetros() {
			allMetros = [
				{ metroCode: -1, state: 'AK', metro: 'entire state' },
				{ metroCode: 380, state: 'AK', metro: 'Anchorage' },
				{ metroCode: -1, state: 'AL', metro: 'entire state' },
				{ metroCode: 450, state: 'AL', metro: 'Anniston' },
				{ metroCode: 580, state: 'AL', metro: 'Auburn-Opelika' },
				{ metroCode: 1000, state: 'AL', metro: 'Birmingham' },
				{ metroCode: 2030, state: 'AL', metro: 'Decatur' },
				{ metroCode: 2180, state: 'AL', metro: 'Dothan' },
				{ metroCode: 2650, state: 'AL', metro: 'Florence' },
				{ metroCode: 2880, state: 'AL', metro: 'Gadsden' },
				{ metroCode: 3440, state: 'AL', metro: 'Huntsville' },
				{ metroCode: 5160, state: 'AL', metro: 'Mobile' },
				{ metroCode: 5240, state: 'AL', metro: 'Montgomery' },
				{ metroCode: 1800, state: 'AL', metro: 'Phenix City' },
				{ metroCode: 8600, state: 'AL', metro: 'Tuscaloosa' },
				{ metroCode: -1, state: 'AR', metro: 'entire state' },
				{ metroCode: 2580, state: 'AR', metro: 'Fayetteville-Springdale-Rogers' },
				{ metroCode: 2720, state: 'AR', metro: 'Ft Smith' },
				{ metroCode: 3700, state: 'AR', metro: 'Jonesboro' },
				{ metroCode: 4400, state: 'AR', metro: 'Little Rock' },
				{ metroCode: 6240, state: 'AR', metro: 'Pine Bluff' },
				{ metroCode: 8360, state: 'AR', metro: 'Texarkana' },
				{ metroCode: 4920, state: 'AR', metro: 'W Memphis' },
				{ metroCode: -1, state: 'AZ', metro: 'entire state' },
				{ metroCode: 2620, state: 'AZ', metro: 'Flagstaff' },
				{ metroCode: 4120, state: 'AZ', metro: 'Kingman' },
				{ metroCode: 6200, state: 'AZ', metro: 'Phoenix' },
				{ metroCode: 8520, state: 'AZ', metro: 'Tucson' },
				{ metroCode: 9360, state: 'AZ', metro: 'Yuma' },
				{ metroCode: -1, state: 'CA', metro: 'entire state' },
				{ metroCode: 680, state: 'CA', metro: 'Bakersfield' },
				{ metroCode: 1620, state: 'CA', metro: 'Chico-Paradise' },
				{ metroCode: 2840, state: 'CA', metro: 'Fresno' },
				{ metroCode: 4480, state: 'CA', metro: 'Angeles-Long Beach' },
				{ metroCode: 4940, state: 'CA', metro: 'Merced' },
				{ metroCode: 5170, state: 'CA', metro: 'Modesto' },
				{ metroCode: 5775, state: 'CA', metro: 'Oakland' },
				{ metroCode: 5945, state: 'CA', metro: 'Orange County' },
				{ metroCode: 6690, state: 'CA', metro: 'Redding' },
				{ metroCode: 6780, state: 'CA', metro: 'Riverside-San Bernardino' },
				{ metroCode: 6920, state: 'CA', metro: 'Sacramento' },
				{ metroCode: 7120, state: 'CA', metro: 'Salinas' },
				{ metroCode: 7320, state: 'CA', metro: 'San Diego' },
				{ metroCode: 7360, state: 'CA', metro: 'San Francisco' },
				{ metroCode: 7400, state: 'CA', metro: 'San Jose' },
				{ metroCode: 7460, state: 'CA', metro: 'San Luis Obispo-Atascadero-Paso Robles' },
				{ metroCode: 7480, state: 'CA', metro: 'Santa Barbara-Santa Maria-Lompoc' },
				{ metroCode: 7485, state: 'CA', metro: 'Santa Cruz-Watsonville' },
				{ metroCode: 7500, state: 'CA', metro: 'Santa Rosa' },
				{ metroCode: 8120, state: 'CA', metro: 'Stockton-Lodi' },
				{ metroCode: 8720, state: 'CA', metro: 'Vallejo-Fairfield-Napa' },
				{ metroCode: 8735, state: 'CA', metro: 'Ventura' },
				{ metroCode: 8780, state: 'CA', metro: 'Visalia-Tulare-Porterville' },
				{ metroCode: 9270, state: 'CA', metro: 'Yolo' },
				{ metroCode: 9340, state: 'CA', metro: 'Yuba City' },
				{ metroCode: -1, state: 'CO', metro: 'entire state' },
				{ metroCode: 1125, state: 'CO', metro: 'Boulder-Longmont' },
				{ metroCode: 1720, state: 'CO', metro: 'Colorado Springs' },
				{ metroCode: 2080, state: 'CO', metro: 'Denver' },
				{ metroCode: 2670, state: 'CO', metro: 'Fort Collins-Loveland' },
				{ metroCode: 2995, state: 'CO', metro: 'Grand Junction' },
				{ metroCode: 3060, state: 'CO', metro: 'Greeley' },
				{ metroCode: 6560, state: 'CO', metro: 'Pueblo' },
				{ metroCode: -1, state: 'CT', metro: 'entire state' },
				{ metroCode: 1160, state: 'CT', metro: 'Bridgeport' },
				{ metroCode: 1930, state: 'CT', metro: 'Danbury' },
				{ metroCode: 3280, state: 'CT', metro: 'Hartford' },
				{ metroCode: 5020, state: 'CT', metro: 'Middletown' },
				{ metroCode: 5440, state: 'CT', metro: 'New Britain' },
				{ metroCode: 5480, state: 'CT', metro: 'New Haven-Meriden' },
				{ metroCode: 5520, state: 'CT', metro: 'New London-Norwich' },
				{ metroCode: 5760, state: 'CT', metro: 'Norwalk' },
				{ metroCode: 8040, state: 'CT', metro: 'Stamford-Norwalk' },
				{ metroCode: 8880, state: 'CT', metro: 'Waterbury' },
				{ metroCode: -1, state: 'DC', metro: 'entire state' },
				{ metroCode: 8840, state: 'DC', metro: 'Washington DC' },
				{ metroCode: -1, state: 'DE', metro: 'entire state' },
				{ metroCode: 2190, state: 'DE', metro: 'Dover' },
				{ metroCode: 9160, state: 'DE', metro: 'Wilmington-Newark' },
				{ metroCode: -1, state: 'FL', metro: 'entire state' },
				{ metroCode: 1140, state: 'FL', metro: 'Bradenton' },
				{ metroCode: 2020, state: 'FL', metro: 'Daytona Beach' },
				{ metroCode: 2680, state: 'FL', metro: 'Ft Lauderdale' },
				{ metroCode: 2700, state: 'FL', metro: 'Ft Myers-Cape Coral' },
				{ metroCode: 2710, state: 'FL', metro: 'Ft Pierce-Port St Lucie' },
				{ metroCode: 2750, state: 'FL', metro: 'Ft Walton Beach' },
				{ metroCode: 2900, state: 'FL', metro: 'Gainesville' },
				{ metroCode: 3600, state: 'FL', metro: 'Jacksonville' },
				{ metroCode: 3980, state: 'FL', metro: 'Lakeland-Winter Haven' },
				{ metroCode: 4900, state: 'FL', metro: 'Melbourne-Titusville-Palm Bay' },
				{ metroCode: 5000, state: 'FL', metro: 'Miami' },
				{ metroCode: 5345, state: 'FL', metro: 'Naples' },
				{ metroCode: 5790, state: 'FL', metro: 'Ocala' },
				{ metroCode: 5960, state: 'FL', metro: 'Orlando' },
				{ metroCode: 6015, state: 'FL', metro: 'Panama City' },
				{ metroCode: 6080, state: 'FL', metro: 'Pensacola' },
				{ metroCode: 6580, state: 'FL', metro: 'Punta Gorda' },
				{ metroCode: 7510, state: 'FL', metro: 'Sarasota-Bradenton' },
				{ metroCode: 8240, state: 'FL', metro: 'Tallahassee' },
				{ metroCode: 8280, state: 'FL', metro: 'Tampa-St Petersburg-Clearwater' },
				{ metroCode: 8960, state: 'FL', metro: 'W Palm Beach-Boca Raton' },
				{ metroCode: -1, state: 'GA', metro: 'entire state' },
				{ metroCode: 120, state: 'GA', metro: 'Albany' },
				{ metroCode: 500, state: 'GA', metro: 'Athens' },
				{ metroCode: 520, state: 'GA', metro: 'Atlanta' },
				{ metroCode: 600, state: 'GA', metro: 'Augusta' },
				{ metroCode: 1800, state: 'GA', metro: 'Columbus' },
				{ metroCode: 4680, state: 'GA', metro: 'Macon' },
				{ metroCode: 7520, state: 'GA', metro: 'Savannah' },
				{ metroCode: -1, state: 'HI', metro: 'entire state' },
				{ metroCode: 3320, state: 'HI', metro: 'Honolulu' },
				{ metroCode: -1, state: 'IA', metro: 'entire state' },
				{ metroCode: 1360, state: 'IA', metro: 'Cedar Rapids' },
				{ metroCode: 5920, state: 'IA', metro: 'Council Bluffs' },
				{ metroCode: 1960, state: 'IA', metro: 'Davenport-Moline-Rock Island' },
				{ metroCode: 2120, state: 'IA', metro: 'Des Moines' },
				{ metroCode: 2200, state: 'IA', metro: 'Dubuque' },
				{ metroCode: 3500, state: 'IA', metro: 'Iowa City' },
				{ metroCode: 7720, state: 'IA', metro: 'Sioux City' },
				{ metroCode: 8920, state: 'IA', metro: 'Waterloo-Cedar Falls' },
				{ metroCode: -1, state: 'ID', metro: 'entire state' },
				{ metroCode: 1080, state: 'ID', metro: 'Boise' },
				{ metroCode: 6340, state: 'ID', metro: 'Pocatello' },
				{ metroCode: -1, state: 'IL', metro: 'entire state' },
				{ metroCode: 620, state: 'IL', metro: 'Aurora-Elgin' },
				{ metroCode: 1040, state: 'IL', metro: 'Bloomington-Normal' },
				{ metroCode: 1400, state: 'IL', metro: 'Champaign-Urbana' },
				{ metroCode: 1600, state: 'IL', metro: 'Chicago' },
				{ metroCode: 1960, state: 'IL', metro: 'Davenport-Moline-Rock Island' },
				{ metroCode: 2040, state: 'IL', metro: 'Decatur' },
				{ metroCode: 7040, state: 'IL', metro: 'E St Louis' },
				{ metroCode: 3690, state: 'IL', metro: 'Joliet' },
				{ metroCode: 3740, state: 'IL', metro: 'Kankakee' },
				{ metroCode: 6120, state: 'IL', metro: 'Peoria-Pekin' },
				{ metroCode: 6880, state: 'IL', metro: 'Rockford' },
				{ metroCode: 7880, state: 'IL', metro: 'Springfield' },
				{ metroCode: -1, state: 'IN', metro: 'entire state' },
				{ metroCode: 400, state: 'IN', metro: 'Anderson' },
				{ metroCode: 1020, state: 'IN', metro: 'Bloomington' },
				{ metroCode: 2330, state: 'IN', metro: 'Elkhart-Goshen' },
				{ metroCode: 2440, state: 'IN', metro: 'Evansville-Henderson' },
				{ metroCode: 2760, state: 'IN', metro: 'Ft Wayne' },
				{ metroCode: 2960, state: 'IN', metro: 'Gary' },
				{ metroCode: 3480, state: 'IN', metro: 'Indianapolis' },
				{ metroCode: 3850, state: 'IN', metro: 'Kokomo' },
				{ metroCode: 3920, state: 'IN', metro: 'Lafayette' },
				{ metroCode: 5280, state: 'IN', metro: 'Muncie' },
				{ metroCode: 4520, state: 'IN', metro: 'New Albany' },
				{ metroCode: 7800, state: 'IN', metro: 'S Bend' },
				{ metroCode: 8320, state: 'IN', metro: 'Terre Haute' },
				{ metroCode: -1, state: 'KS', metro: 'entire state' },
				{ metroCode: 3760, state: 'KS', metro: 'Kansas City' },
				{ metroCode: 4150, state: 'KS', metro: 'Lawrence' },
				{ metroCode: 8440, state: 'KS', metro: 'Topeka' },
				{ metroCode: 9040, state: 'KS', metro: 'Wichita' },
				{ metroCode: -1, state: 'KY', metro: 'entire state' },
				{ metroCode: 1640, state: 'KY', metro: 'Cincinnati-Covington' },
				{ metroCode: 1660, state: 'KY', metro: 'Clarksville-Hopkinsville' },
				{ metroCode: 3400, state: 'KY', metro: 'Huntington-Ashland' },
				{ metroCode: 4280, state: 'KY', metro: 'Lexington-Fayette' },
				{ metroCode: 4520, state: 'KY', metro: 'Louisville' },
				{ metroCode: 5990, state: 'KY', metro: 'Owensboro' },
				{ metroCode: -1, state: 'LA', metro: 'entire state' },
				{ metroCode: 220, state: 'LA', metro: 'Alexandria' },
				{ metroCode: 760, state: 'LA', metro: 'Baton Rouge' },
				{ metroCode: 3350, state: 'LA', metro: 'Houma' },
				{ metroCode: 3880, state: 'LA', metro: 'Lafayette' },
				{ metroCode: 3960, state: 'LA', metro: 'Lake Charles' },
				{ metroCode: 3965, state: 'LA', metro: 'Lake County' },
				{ metroCode: 5200, state: 'LA', metro: 'Monroe' },
				{ metroCode: 5560, state: 'LA', metro: 'New Orleans' },
				{ metroCode: 7680, state: 'LA', metro: 'Shreveport' },
				{ metroCode: -1, state: 'MA', metro: 'entire state' },
				{ metroCode: 740, state: 'MA', metro: 'Barnstable-Yarmouth' },
				{ metroCode: 1120, state: 'MA', metro: 'Boston' },
				{ metroCode: 1200, state: 'MA', metro: 'Brockton' },
				{ metroCode: 2480, state: 'MA', metro: 'Fall River' },
				{ metroCode: 2600, state: 'MA', metro: 'Fitchburg-Leominster' },
				{ metroCode: 4160, state: 'MA', metro: 'Lawrence' },
				{ metroCode: 4560, state: 'MA', metro: 'Lowell' },
				{ metroCode: 5400, state: 'MA', metro: 'New Bedford' },
				{ metroCode: 6060, state: 'MA', metro: 'Pawtucket-Woonsocket-Attleboro' },
				{ metroCode: 6320, state: 'MA', metro: 'Pittsfield' },
				{ metroCode: 6480, state: 'MA', metro: 'Providence-Fall River-Warwick' },
				{ metroCode: 7090, state: 'MA', metro: 'Salem-Gloucester' },
				{ metroCode: 8000, state: 'MA', metro: 'Springfield' },
				{ metroCode: 9240, state: 'MA', metro: 'Worcester' },
				{ metroCode: -1, state: 'MD', metro: 'entire state' },
				{ metroCode: 720, state: 'MD', metro: 'Baltimore' },
				{ metroCode: 1900, state: 'MD', metro: 'Cumberland' },
				{ metroCode: 3180, state: 'MD', metro: 'Hagerstown' },
				{ metroCode: 8840, state: 'MD', metro: 'Washington DC' },
				{ metroCode: 9160, state: 'MD', metro: 'Wilmington-Newark' },
				{ metroCode: -1, state: 'ME', metro: 'entire state' },
				{ metroCode: 730, state: 'ME', metro: 'Bangor' },
				{ metroCode: 4240, state: 'ME', metro: 'Lewiston-Auburn' },
				{ metroCode: 6400, state: 'ME', metro: 'Portland' },
				{ metroCode: 6450, state: 'ME', metro: 'Portsmouth-Rochester' },
				{ metroCode: -1, state: 'MI', metro: 'entire state' },
				{ metroCode: 440, state: 'MI', metro: 'Ann Arbor' },
				{ metroCode: 780, state: 'MI', metro: 'Battle Creek' },
				{ metroCode: 870, state: 'MI', metro: 'Benton Harbor' },
				{ metroCode: 2160, state: 'MI', metro: 'Detroit' },
				{ metroCode: 2640, state: 'MI', metro: 'Flint' },
				{ metroCode: 3000, state: 'MI', metro: 'Grand Rapids-Muskegon-Holland' },
				{ metroCode: 3520, state: 'MI', metro: 'Jackson' },
				{ metroCode: 3720, state: 'MI', metro: 'Kalamazoo-Battle Creek' },
				{ metroCode: 4040, state: 'MI', metro: 'Lansing-East Lansing' },
				{ metroCode: 6960, state: 'MI', metro: 'Saginaw-Bay City-Midland' },
				{ metroCode: -1, state: 'MN', metro: 'entire state' },
				{ metroCode: 2240, state: 'MN', metro: 'Duluth-Superior' },
				{ metroCode: 2520, state: 'MN', metro: 'Fargo-Moorhead' },
				{ metroCode: 2985, state: 'MN', metro: 'Grand Forks' },
				{ metroCode: 5120, state: 'MN', metro: 'Minneapolis-St. Paul' },
				{ metroCode: 6820, state: 'MN', metro: 'Rochester' },
				{ metroCode: 6980, state: 'MN', metro: 'St Cloud' },
				{ metroCode: -1, state: 'MO', metro: 'entire state' },
				{ metroCode: 1740, state: 'MO', metro: 'Columbia' },
				{ metroCode: 3710, state: 'MO', metro: 'Joplin' },
				{ metroCode: 3760, state: 'MO', metro: 'Kansas City' },
				{ metroCode: 7920, state: 'MO', metro: 'Springfield' },
				{ metroCode: 7000, state: 'MO', metro: 'St Joesph' },
				{ metroCode: 7040, state: 'MO', metro: 'St Louis' },
				{ metroCode: -1, state: 'MS', metro: 'entire state' },
				{ metroCode: 920, state: 'MS', metro: 'Biloxi-Gulfport-Pascagoula' },
				{ metroCode: 3285, state: 'MS', metro: 'Hattiesburg' },
				{ metroCode: 3560, state: 'MS', metro: 'Jackson' },
				{ metroCode: 4920, state: 'MS', metro: 'Memphis' },
				{ metroCode: -1, state: 'MT', metro: 'entire state' },
				{ metroCode: 880, state: 'MT', metro: 'Billings' },
				{ metroCode: 3040, state: 'MT', metro: 'Great Falls' },
				{ metroCode: 5140, state: 'MT', metro: 'Missoula' },
				{ metroCode: -1, state: 'NC', metro: 'entire state' },
				{ metroCode: 480, state: 'NC', metro: 'Asheville' },
				{ metroCode: 1520, state: 'NC', metro: 'Charlotte-Gastonia-Rock Hill' },
				{ metroCode: 2560, state: 'NC', metro: 'Fayetteville' },
				{ metroCode: 2980, state: 'NC', metro: 'Goldsboro' },
				{ metroCode: 3120, state: 'NC', metro: 'Greensboro-WinstonSalem-High Pt' },
				{ metroCode: 3150, state: 'NC', metro: 'Greenville' },
				{ metroCode: 3290, state: 'NC', metro: 'Hickory-Morganton-Lenoir' },
				{ metroCode: 3605, state: 'NC', metro: 'Jacksonville' },
				{ metroCode: 5720, state: 'NC', metro: 'Norfolk-Virginia Beach-Newport News' },
				{ metroCode: 6640, state: 'NC', metro: 'Raleigh-Durham-Chapel Hill' },
				{ metroCode: 6895, state: 'NC', metro: 'Rocky Mount' },
				{ metroCode: 9200, state: 'NC', metro: 'Wilmington' },
				{ metroCode: -1, state: 'ND', metro: 'entire state' },
				{ metroCode: 1010, state: 'ND', metro: 'Bismarck' },
				{ metroCode: 2520, state: 'ND', metro: 'Fargo-Moorhead' },
				{ metroCode: 2985, state: 'ND', metro: 'Grand Forks' },
				{ metroCode: -1, state: 'NE', metro: 'entire state' },
				{ metroCode: 4360, state: 'NE', metro: 'Lincoln' },
				{ metroCode: 5920, state: 'NE', metro: 'Omaha' },
				{ metroCode: 7720, state: 'NE', metro: 'S Sioux City' },
				{ metroCode: -1, state: 'NH', metro: 'entire state' },
				{ metroCode: 4160, state: 'NH', metro: 'Lawrence' },
				{ metroCode: 4760, state: 'NH', metro: 'Manchester' },
				{ metroCode: 5350, state: 'NH', metro: 'Nashua' },
				{ metroCode: 6450, state: 'NH', metro: 'Portsmouth-Rochester' },
				{ metroCode: -1, state: 'NJ', metro: 'entire state' },
				{ metroCode: 560, state: 'NJ', metro: 'Atlantic City-Cape May' },
				{ metroCode: 875, state: 'NJ', metro: 'Bergen-Passaic' },
				{ metroCode: 6160, state: 'NJ', metro: 'Camden' },
				{ metroCode: 3640, state: 'NJ', metro: 'Jersey City' },
				{ metroCode: 5015, state: 'NJ', metro: 'Middlesex-Somerset-Hunterdon' },
				{ metroCode: 5190, state: 'NJ', metro: 'Monmouth-Ocean' },
				{ metroCode: 5640, state: 'NJ', metro: 'Newark' },
				{ metroCode: 8480, state: 'NJ', metro: 'Trenton' },
				{ metroCode: 8760, state: 'NJ', metro: 'Vineland-Millville-Bridgeton' },
				{ metroCode: -1, state: 'NM', metro: 'entire state' },
				{ metroCode: 200, state: 'NM', metro: 'Albuquerque' },
				{ metroCode: 4100, state: 'NM', metro: 'Las Cruces' },
				{ metroCode: 7490, state: 'NM', metro: 'Santa Fe' },
				{ metroCode: -1, state: 'NV', metro: 'entire state' },
				{ metroCode: 4120, state: 'NV', metro: 'Las Vegas' },
				{ metroCode: 6720, state: 'NV', metro: 'Reno' },
				{ metroCode: -1, state: 'NY', metro: 'entire state' },
				{ metroCode: 160, state: 'NY', metro: 'Albany' },
				{ metroCode: 960, state: 'NY', metro: 'Binghamton' },
				{ metroCode: 1280, state: 'NY', metro: 'Buffalo-Niagara Falls' },
				{ metroCode: 2281, state: 'NY', metro: 'Dutchess County' },
				{ metroCode: 2335, state: 'NY', metro: 'Elmira' },
				{ metroCode: 2975, state: 'NY', metro: 'Glens Falls' },
				{ metroCode: 3610, state: 'NY', metro: 'Jamestown' },
				{ metroCode: 5380, state: 'NY', metro: 'Nassau-Suffolk' },
				{ metroCode: 5600, state: 'NY', metro: 'New York City' },
				{ metroCode: 5660, state: 'NY', metro: 'Newburgh' },
				{ metroCode: 5950, state: 'NY', metro: 'Orange County' },
				{ metroCode: 6840, state: 'NY', metro: 'Rochester' },
				{ metroCode: 8160, state: 'NY', metro: 'Syracuse' },
				{ metroCode: 8680, state: 'NY', metro: 'Utica-Rome' },
				{ metroCode: -1, state: 'OH', metro: 'entire state' },
				{ metroCode: 80, state: 'OH', metro: 'Akron' },
				{ metroCode: 1320, state: 'OH', metro: 'Canton-Massillon' },
				{ metroCode: 1640, state: 'OH', metro: 'Cincinnati-Covington' },
				{ metroCode: 1680, state: 'OH', metro: 'Cleveland-Lorain-Elyria' },
				{ metroCode: 1840, state: 'OH', metro: 'Columbus' },
				{ metroCode: 2000, state: 'OH', metro: 'Dayton-Springfield' },
				{ metroCode: 3200, state: 'OH', metro: 'Hamilton-Middletown' },
				{ metroCode: 3400, state: 'OH', metro: 'Huntington-Ashland' },
				{ metroCode: 4320, state: 'OH', metro: 'Lima' },
				{ metroCode: 4800, state: 'OH', metro: 'Mansfield' },
				{ metroCode: 6020, state: 'OH', metro: 'Marietta' },
				{ metroCode: 8080, state: 'OH', metro: 'Steubenville-Weirton' },
				{ metroCode: 8400, state: 'OH', metro: 'Toledo' },
				{ metroCode: 9320, state: 'OH', metro: 'Youngstown-Warren' },
				{ metroCode: -1, state: 'OK', metro: 'entire state' },
				{ metroCode: 2340, state: 'OK', metro: 'Enid' },
				{ metroCode: 4200, state: 'OK', metro: 'Lawton' },
				{ metroCode: 5880, state: 'OK', metro: 'Oklahoma City' },
				{ metroCode: 2720, state: 'OK', metro: 'Sallisaw' },
				{ metroCode: 8560, state: 'OK', metro: 'Tulsa' },
				{ metroCode: -1, state: 'OR', metro: 'entire state' },
				{ metroCode: 1890, state: 'OR', metro: 'Corvallis' },
				{ metroCode: 2400, state: 'OR', metro: 'Eugene-Springfield' },
				{ metroCode: 4890, state: 'OR', metro: 'Medford-Ashland' },
				{ metroCode: 6440, state: 'OR', metro: 'Portland-Vancouver' },
				{ metroCode: 7080, state: 'OR', metro: 'Salem' },
				{ metroCode: -1, state: 'PA', metro: 'entire state' },
				{ metroCode: 240, state: 'PA', metro: 'Allentown-Bethlehem-Easton' },
				{ metroCode: 280, state: 'PA', metro: 'Altoona' },
				{ metroCode: 845, state: 'PA', metro: 'Beaver County' },
				{ metroCode: 2360, state: 'PA', metro: 'Erie' },
				{ metroCode: 3240, state: 'PA', metro: 'Harrisburg-Lebanon-Carlisle' },
				{ metroCode: 3680, state: 'PA', metro: 'Johnstown' },
				{ metroCode: 4000, state: 'PA', metro: 'Lancaster' },
				{ metroCode: 6160, state: 'PA', metro: 'Philadelphia' },
				{ metroCode: 6280, state: 'PA', metro: 'Pittsburgh' },
				{ metroCode: 6680, state: 'PA', metro: 'Reading' },
				{ metroCode: 7560, state: 'PA', metro: 'Scranton--Wilkes-Barre--Hazleton' },
				{ metroCode: 7610, state: 'PA', metro: 'Sharon' },
				{ metroCode: 8050, state: 'PA', metro: 'State College' },
				{ metroCode: 9140, state: 'PA', metro: 'Williamsport' },
				{ metroCode: 9280, state: 'PA', metro: 'York' },
				{ metroCode: -1, state: 'RI', metro: 'entire state' },
				{ metroCode: 2480, state: 'RI', metro: 'Fall River' },
				{ metroCode: 6060, state: 'RI', metro: 'Pawtucket-Woonsocket-Attleboro' },
				{ metroCode: 6480, state: 'RI', metro: 'Providence-Fall River-Warwick' },
				{ metroCode: -1, state: 'SC', metro: 'entire state' },
				{ metroCode: 600, state: 'SC', metro: 'Aiken' },
				{ metroCode: 405, state: 'SC', metro: 'Anderson' },
				{ metroCode: 1440, state: 'SC', metro: 'Charleston' },
				{ metroCode: 1760, state: 'SC', metro: 'Columbia' },
				{ metroCode: 2655, state: 'SC', metro: 'Florence' },
				{ metroCode: 3160, state: 'SC', metro: 'Greenville-Spartanburg-Anderson' },
				{ metroCode: 5330, state: 'SC', metro: 'Myrtle Beach' },
				{ metroCode: 8140, state: 'SC', metro: 'Sumter' },
				{ metroCode: -1, state: 'SD', metro: 'entire state' },
				{ metroCode: 6660, state: 'SD', metro: 'Rapid City' },
				{ metroCode: 7760, state: 'SD', metro: 'Sioux Falls' },
				{ metroCode: -1, state: 'TN', metro: 'entire state' },
				{ metroCode: 1560, state: 'TN', metro: 'Chattanooga' },
				{ metroCode: 1660, state: 'TN', metro: 'Clarksville-Hopkinsville' },
				{ metroCode: 3580, state: 'TN', metro: 'Jackson' },
				{ metroCode: 3660, state: 'TN', metro: 'Johnson City-Kingsport-Bristol' },
				{ metroCode: 3840, state: 'TN', metro: 'Knoxville' },
				{ metroCode: 4920, state: 'TN', metro: 'Memphis' },
				{ metroCode: 5360, state: 'TN', metro: 'Nashville' },
				{ metroCode: -1, state: 'TX', metro: 'entire state' },
				{ metroCode: 40, state: 'TX', metro: 'Abilene' },
				{ metroCode: 320, state: 'TX', metro: 'Amarillo' },
				{ metroCode: 640, state: 'TX', metro: 'Austin-San Marcos' },
				{ metroCode: 840, state: 'TX', metro: 'Beaumont-Port Arthur' },
				{ metroCode: 1145, state: 'TX', metro: 'Brazoria' },
				{ metroCode: 1240, state: 'TX', metro: 'Brownsville-Harlingen-San Benito' },
				{ metroCode: 1260, state: 'TX', metro: 'Bryan-College Station' },
				{ metroCode: 1880, state: 'TX', metro: 'Corpus Christi' },
				{ metroCode: 1920, state: 'TX', metro: 'Dallas' },
				{ metroCode: 2320, state: 'TX', metro: 'El Paso' },
				{ metroCode: 2800, state: 'TX', metro: 'Ft Worth-Arlington' },
				{ metroCode: 2920, state: 'TX', metro: 'Galveston-Texas City' },
				{ metroCode: 3360, state: 'TX', metro: 'Houston' },
				{ metroCode: 3810, state: 'TX', metro: 'Killeen-Temple' },
				{ metroCode: 44, state: 'TX', metro: 'Lanius' },
				{ metroCode: 4080, state: 'TX', metro: 'Laredo' },
				{ metroCode: 4420, state: 'TX', metro: 'Longview-Marshall' },
				{ metroCode: 4600, state: 'TX', metro: 'Lubbock' },
				{ metroCode: 4880, state: 'TX', metro: 'McAllen-Edinburg-Mission' },
				{ metroCode: 5800, state: 'TX', metro: 'Odessa-Midland' },
				{ metroCode: 7200, state: 'TX', metro: 'San Angelo' },
				{ metroCode: 7240, state: 'TX', metro: 'San Antonio' },
				{ metroCode: 7640, state: 'TX', metro: 'Sherman-Denison' },
				{ metroCode: 8360, state: 'TX', metro: 'Texarkana' },
				{ metroCode: 8640, state: 'TX', metro: 'Tyler' },
				{ metroCode: 8750, state: 'TX', metro: 'Victoria' },
				{ metroCode: 8800, state: 'TX', metro: 'Waco' },
				{ metroCode: 9080, state: 'TX', metro: 'Wichita Falls' },
				{ metroCode: -1, state: 'UT', metro: 'entire state' },
				{ metroCode: 2620, state: 'UT', metro: 'Flagstaff' },
				{ metroCode: 6520, state: 'UT', metro: 'Provo-Orem' },
				{ metroCode: 7160, state: 'UT', metro: 'Salt Lake City-Ogden' },
				{ metroCode: -1, state: 'VA', metro: 'entire state' },
				{ metroCode: 1540, state: 'VA', metro: 'Charlottesville' },
				{ metroCode: 1950, state: 'VA', metro: 'Danville' },
				{ metroCode: 3660, state: 'VA', metro: 'Johnson City-Kingsport-Bristol' },
				{ metroCode: 4640, state: 'VA', metro: 'Lynchburg' },
				{ metroCode: 5720, state: 'VA', metro: 'Norfolk-Virginia Beach-Newport News' },
				{ metroCode: 6760, state: 'VA', metro: 'Richmond-Petersburg' },
				{ metroCode: 6800, state: 'VA', metro: 'Roanoke' },
				{ metroCode: 8840, state: 'VA', metro: 'Washington DC' },
				{ metroCode: -1, state: 'VT', metro: 'entire state' },
				{ metroCode: 1305, state: 'VT', metro: 'Burlington' },
				{ metroCode: -1, state: 'WA', metro: 'entire state' },
				{ metroCode: 860, state: 'WA', metro: 'Bellingham' },
				{ metroCode: 1150, state: 'WA', metro: 'Bremerton' },
				{ metroCode: 5910, state: 'WA', metro: 'Olympia' },
				{ metroCode: 6440, state: 'WA', metro: 'Portland-Vancouver' },
				{ metroCode: 6740, state: 'WA', metro: 'Richland-Kennewick-Pasco' },
				{ metroCode: 7600, state: 'WA', metro: 'Seattle-Bellevue-Everett' },
				{ metroCode: 7840, state: 'WA', metro: 'Spokane' },
				{ metroCode: 8200, state: 'WA', metro: 'Tacoma' },
				{ metroCode: 8725, state: 'WA', metro: 'Vancouver' },
				{ metroCode: 9260, state: 'WA', metro: 'Yakima' },
				{ metroCode: -1, state: 'WI', metro: 'entire state' },
				{ metroCode: 460, state: 'WI', metro: 'Appleton-Oshkosh-Neenah' },
				{ metroCode: 2240, state: 'WI', metro: 'Duluth-Superior' },
				{ metroCode: 2290, state: 'WI', metro: 'Eau Claire' },
				{ metroCode: 3080, state: 'WI', metro: 'Green Bay' },
				{ metroCode: 3620, state: 'WI', metro: 'Janesville-Beloit' },
				{ metroCode: 3800, state: 'WI', metro: 'Kenosha' },
				{ metroCode: 3870, state: 'WI', metro: 'La Crosse' },
				{ metroCode: 4720, state: 'WI', metro: 'Madison' },
				{ metroCode: 5080, state: 'WI', metro: 'Milwaukee-Waukesha' },
				{ metroCode: 5120, state: 'WI', metro: 'Minneapolis-St. Paul' },
				{ metroCode: 6600, state: 'WI', metro: 'Racine' },
				{ metroCode: 7620, state: 'WI', metro: 'Sheboygan' },
				{ metroCode: 8940, state: 'WI', metro: 'Wausau' },
				{ metroCode: -1, state: 'WV', metro: 'entire state' },
				{ metroCode: 1480, state: 'WV', metro: 'Charleston' },
				{ metroCode: 1900, state: 'WV', metro: 'Cumberland' },
				{ metroCode: 3400, state: 'WV', metro: 'Huntington-Ashland' },
				{ metroCode: 6020, state: 'WV', metro: 'Parkersburg' },
				{ metroCode: 8080, state: 'WV', metro: 'Steubenville-Weirton' },
				{ metroCode: 8840, state: 'WV', metro: 'Washington DC' },
				{ metroCode: 9000, state: 'WV', metro: 'Wheeling' },
				{ metroCode: -1, state: 'WY', metro: 'entire state' },
				{ metroCode: 1350, state: 'WY', metro: 'Casper' },
				{ metroCode: 1580, state: 'WY', metro: 'Cheyenne' }
			];

			scope.m.states = states();
		}

		function loadData(lanesOnly) {
			carrierRegistrationService.lookupPreferredAreasLanes(scope.carrierId)
				.then(function(response) {
					scope.m.preferredLanes = response.data.preferredLanes;
					if (lanesOnly)
						return;
					scope.m.preferredAreas = {};
					scope.m.hasServiceInMexico = response.data.hasServiceInMexico;
					if (response.data.preferredAreas) {
						response.data.preferredAreas.forEach(function(state) {
							scope.m.preferredAreas[state.toLowerCase()] = true;
						});

						provinceChange();
						stateChange();

						scope.m.showCanadaMexico = scope.m.preferredAreas.ab ||
                            scope.m.preferredAreas.bc ||
                            scope.m.preferredAreas.mb ||
                            scope.m.preferredAreas.sk ||
                            scope.m.preferredAreas.on ||
                            scope.m.preferredAreas.pq ||
                            scope.m.preferredAreas.nb ||
                            scope.m.preferredAreas.nf ||
                            scope.m.preferredAreas.ns ||
                            scope.m.preferredAreas.pe ||
                            scope.m.hasServiceInMexico;
					}
					scope.m.showUnitedStates = !scope.m.allUsZones;
				});
		}

		function registerObserverHandlers() {
			scope.$watch('m.newOrginState',
				function(newVal) {
					if (newVal) {
						filterOrginMetros();
					}
				});
			scope.$watch('m.newDestinationState',
				function(newVal) {
					if (newVal) {
						filterDestinationMetros();
					}
				});

			scope.$on('$destroy',
				function() {
					window.onbeforeunload = undefined;
				});

			scope.$on('$locationChangeStart',
				function(event) {
					if (scope.m.isDirty || scope.m.showNewLane) {
						if (!
						confirm('You have unsaved data. If you leave this page any changes will be lost. Changes are saved using the Save buttons at the bottom of the page. Are you sure you want to leave the page?')) {
							event.preventDefault();
						}
					}
				});

			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_START_CHANGE_CARRIER_PROFILE_VIEW, handler: saveData },
					{ message: observerMessages.COB_OBSERVER_SET_PENDING_TAB, handler: setPendingTab }
				]);
		}

		function setIsDirty() {
			scope.m.isDirty = true;
			window.onbeforeunload = function() {
				return 'You have unsaved data. If you leave this page any changes will be lost. Changes are saved using the Save buttons at the bottom of the page.';
			};
		}

		function saveData(callback) {
			if (!scope.m.isBroker) {
				carrierRegistrationService.visitedSection('laneCoverage', scope.carrierId, scope.brokerId)
					.then(function() {
						observerService.sendMessageToSubject(scope,
							subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_STATUS,
							'laneCoverage');
						if (scope.m.showNewLane) {
							saveLane();
						}
						savePreferredAreas(callback);
					});

			} else {
				if (scope.m.showNewLane) {
					saveLane();
				}
				savePreferredAreas(callback);
			}
		}

		function states() {
			var cur = '';
			var states = [];
			allMetros.forEach(function(metro) {
				if (cur !== metro.state) {
					states.push(metro.state);
					cur = metro.state;
				}
			});

			return states;
		}

		function filterOrginMetros() {
			var filtered = [];
			scope.m.newOrginMetro = {};

			allMetros.forEach(function(metro) {
				if (scope.m.newOrginState === metro.state) {
					filtered.push(metro);
					if (!scope.m.newOrginMetro.state) {
						scope.m.newOrginMetro = metro;
					}
				}
			});
			scope.m.filteredOrginMetros = filtered;
		}

		function filterDestinationMetros() {
			var filtered = [];
			scope.m.newDestinationMetro = {};

			allMetros.forEach(function(metro) {
				if (scope.m.newDestinationState === metro.state) {
					filtered.push(metro);
					if (!scope.m.newDestinationMetro.state) {
						scope.m.newDestinationMetro = metro;
					}
				}
			});
			scope.m.filteredDestinationMetros = filtered;
		}

		function trashClick(lane) {
			if (lane) {
				for (var i = 0; i < scope.m.preferredLanes.length; i++) {
					if (scope.m.preferredLanes[i].originState === lane.originState)
						if (scope.m.preferredLanes[i].originMetroName === lane.originMetroName)
							if (scope.m.preferredLanes[i].destinationState === lane.destinationState)
								if (scope.m.preferredLanes[i].destinationMetroName === lane.destinationMetroName) {
									carrierRegistrationService.updatePreferredLanes(lane.originState,
										lane.originMetroCode,
										lane.originMetroName,
										lane.destinationState,
										lane.destinationMetroCode,
										lane.destinationMetroName,
										true,
										scope.carrierId)
										.then(function() { loadData(true); });

									return;
								}
				}
			} else {
				scope.m.showNewLane = false;
				if (!scope.m.isDirty) {
					window.onbeforeunload = undefined;
				}
			}

		}

		function saveLane() {
			carrierRegistrationService.updatePreferredLanes(scope.m.newOrginMetro.state,
				scope.m.newOrginMetro.metroCode,
				scope.m.newOrginMetro.metro,
				scope.m.newDestinationMetro.state,
				scope.m.newDestinationMetro.metroCode,
				scope.m.newDestinationMetro.metro,
				false,
				scope.carrierId)
				.then(function() {
					loadData(true);
					if (!scope.m.isDirty) {
						window.onbeforeunload = undefined;
					}
				});

			scope.m.showNewLane = false;
		}

		function addClicK() {
			scope.m.newOrginState = 'AK';
			scope.m.newDestinationState = 'AK';
			filterOrginMetros();
			filterDestinationMetros();
			window.onbeforeunload = function() {
				return 'You have unsaved data. If you leave this page any changes will be lost. Changes are saved using the Save buttons at the bottom of the page.';
			};

			scope.m.showNewLane = true;
		}

		function canadaMexicoClick() {
			scope.m.showCanadaMexico = !scope.m.showCanadaMexico;
		}

		function allCanadianRegionsChange() {
			scope.m.western = scope.m.allCanadianRegions;
			scope.m.central = scope.m.allCanadianRegions;
			scope.m.eastern = scope.m.allCanadianRegions;

			westernChange();
			centralChange();
			easternChange();
		}

		function westernChange() {
			scope.m.preferredAreas.ab = scope.m.western;
			scope.m.preferredAreas.bc = scope.m.western;
			scope.m.preferredAreas.mb = scope.m.western;
			scope.m.preferredAreas.sk = scope.m.western;

			scope.m.allCanadianRegions = scope.m.western && scope.m.central && scope.m.eastern;
		}

		function centralChange() {
			scope.m.preferredAreas.on = scope.m.central;
			scope.m.preferredAreas.pq = scope.m.central;

			scope.m.allCanadianRegions = scope.m.western && scope.m.central && scope.m.eastern;
		}

		function easternChange() {
			scope.m.preferredAreas.nb = scope.m.eastern;
			scope.m.preferredAreas.nf = scope.m.eastern;
			scope.m.preferredAreas.ns = scope.m.eastern;
			scope.m.preferredAreas.pe = scope.m.eastern;

			scope.m.allCanadianRegions = scope.m.western && scope.m.central && scope.m.eastern;
		}

		function provinceChange() {
			scope.m.western = scope.m.preferredAreas.ab &&
                scope.m.preferredAreas.bc &&
                scope.m.preferredAreas.mb &&
                scope.m.preferredAreas.sk;

			scope.m.central = scope.m.preferredAreas.on && scope.m.preferredAreas.pq;

			scope.m.eastern = scope.m.preferredAreas.nb &&
                scope.m.preferredAreas.nf &&
                scope.m.preferredAreas.ns &&
                scope.m.preferredAreas.pe;

			scope.m.allCanadianRegions = scope.m.western && scope.m.central && scope.m.eastern;
		}

		function unitedStatesClick() {
			if (!ignoreAllUsToggle) {
				scope.m.showUnitedStates = !scope.m.showUnitedStates;
			} else {
				ignoreAllUsToggle = false;
			}
		}

		function allUsCheckClick() {
			// Brokers cannot select
			if (scope.m.isBroker) {
				return;
			}

			scope.m.allUsZones = !scope.m.allUsZones;
			allUsZoneChange();
			setIsDirty();

			if (!scope.m.allUsZones && scope.m.showUnitedStates) {
				ignoreAllUsToggle = true;
			}
		}

		function allUsZoneChange() {
			scope.m.zone0 = scope.m.allUsZones;
			scope.m.zone1 = scope.m.allUsZones;
			scope.m.zone2 = scope.m.allUsZones;
			scope.m.zone3 = scope.m.allUsZones;
			scope.m.zone4 = scope.m.allUsZones;
			scope.m.zone5 = scope.m.allUsZones;
			scope.m.zone6 = scope.m.allUsZones;
			scope.m.zone7 = scope.m.allUsZones;
			scope.m.zone8 = scope.m.allUsZones;
			scope.m.zone9 = scope.m.allUsZones;

			zone0Change();
			zone1Change();
			zone2Change();
			zone3Change();
			zone4Change();
			zone5Change();
			zone6Change();
			zone7Change();
			zone8Change();
			zone9Change();

			if (scope.m.allUsZones) {
				scope.m.showUnitedStates = true;
			} else {
				scope.m.showUnitedStates = false;
			}
		}

		function zone0Change() {
			scope.m.preferredAreas.ct = scope.m.zone0;
			scope.m.preferredAreas.ma = scope.m.zone0;
			scope.m.preferredAreas.me = scope.m.zone0;
			scope.m.preferredAreas.nh = scope.m.zone0;
			scope.m.preferredAreas.nj = scope.m.zone0;
			scope.m.preferredAreas.ri = scope.m.zone0;
			scope.m.preferredAreas.vt = scope.m.zone0;

			allUsZonesHelper();
		}

		function zone1Change() {
			scope.m.preferredAreas.de = scope.m.zone1;
			scope.m.preferredAreas.ny = scope.m.zone1;
			scope.m.preferredAreas.pa = scope.m.zone1;

			allUsZonesHelper();
		}

		function zone2Change() {
			scope.m.preferredAreas.md = scope.m.zone2;
			scope.m.preferredAreas.nc = scope.m.zone2;
			scope.m.preferredAreas.sc = scope.m.zone2;
			scope.m.preferredAreas.va = scope.m.zone2;
			scope.m.preferredAreas.dc = scope.m.zone2;
			scope.m.preferredAreas.wv = scope.m.zone2;

			allUsZonesHelper();
		}

		function zone3Change() {
			scope.m.preferredAreas.al = scope.m.zone3;
			scope.m.preferredAreas.fl = scope.m.zone3;
			scope.m.preferredAreas.ga = scope.m.zone3;
			scope.m.preferredAreas.ms = scope.m.zone3;
			scope.m.preferredAreas.tn = scope.m.zone3;

			allUsZonesHelper();
		}

		function zone4Change() {
			scope.m.preferredAreas.in = scope.m.zone4;
			scope.m.preferredAreas.ky = scope.m.zone4;
			scope.m.preferredAreas.mi = scope.m.zone4;
			scope.m.preferredAreas.oh = scope.m.zone4;

			allUsZonesHelper();
		}

		function zone5Change() {
			scope.m.preferredAreas.ia = scope.m.zone5;
			scope.m.preferredAreas.mn = scope.m.zone5;
			scope.m.preferredAreas.mt = scope.m.zone5;
			scope.m.preferredAreas.sd = scope.m.zone5;
			scope.m.preferredAreas.nd = scope.m.zone5;
			scope.m.preferredAreas.wi = scope.m.zone5;

			allUsZonesHelper();
		}

		function zone6Change() {
			scope.m.preferredAreas.il = scope.m.zone6;
			scope.m.preferredAreas.ks = scope.m.zone6;
			scope.m.preferredAreas.mo = scope.m.zone6;
			scope.m.preferredAreas.ne = scope.m.zone6;

			allUsZonesHelper();
		}

		function zone7Change() {
			scope.m.preferredAreas.ar = scope.m.zone7;
			scope.m.preferredAreas.la = scope.m.zone7;
			scope.m.preferredAreas.ok = scope.m.zone7;
			scope.m.preferredAreas.tx = scope.m.zone7;

			allUsZonesHelper();
		}

		function zone8Change() {
			scope.m.preferredAreas.az = scope.m.zone8;
			scope.m.preferredAreas.co = scope.m.zone8;
			scope.m.preferredAreas.id = scope.m.zone8;
			scope.m.preferredAreas.nv = scope.m.zone8;
			scope.m.preferredAreas.nm = scope.m.zone8;
			scope.m.preferredAreas.ut = scope.m.zone8;
			scope.m.preferredAreas.wy = scope.m.zone8;

			allUsZonesHelper();
		}

		function zone9Change() {
			scope.m.preferredAreas.ca = scope.m.zone9;
			scope.m.preferredAreas.or = scope.m.zone9;
			scope.m.preferredAreas.wa = scope.m.zone9;
			scope.m.preferredAreas.ak = scope.m.zone9;

			allUsZonesHelper();
		}

		function stateChange() {
			scope.m.zone0 = scope.m.preferredAreas.ct &&
                scope.m.preferredAreas.ma &&
                scope.m.preferredAreas.me &&
                scope.m.preferredAreas.nh &&
                scope.m.preferredAreas.nj &&
                scope.m.preferredAreas.ri &&
                scope.m.preferredAreas.vt;
			scope.m.zone1 = scope.m.preferredAreas.de &&
                scope.m.preferredAreas.ny &&
                scope.m.preferredAreas.pa;
			scope.m.zone2 = scope.m.preferredAreas.md &&
                scope.m.preferredAreas.nc &&
                scope.m.preferredAreas.sc &&
                scope.m.preferredAreas.va &&
                scope.m.preferredAreas.dc &&
                scope.m.preferredAreas.wv;
			scope.m.zone3 = scope.m.preferredAreas.al &&
                scope.m.preferredAreas.fl &&
                scope.m.preferredAreas.ga &&
                scope.m.preferredAreas.ms &&
                scope.m.preferredAreas.tn;
			scope.m.zone4 = scope.m.preferredAreas.in &&
                scope.m.preferredAreas.ky &&
                scope.m.preferredAreas.mi &&
                scope.m.preferredAreas.oh;
			scope.m.zone5 = scope.m.preferredAreas.ia &&
                scope.m.preferredAreas.mn &&
                scope.m.preferredAreas.mt &&
                scope.m.preferredAreas.sd &&
                scope.m.preferredAreas.nd &&
                scope.m.preferredAreas.nd &&
                scope.m.preferredAreas.wi;
			scope.m.zone6 = scope.m.preferredAreas.il &&
                scope.m.preferredAreas.ks &&
                scope.m.preferredAreas.mo &&
                scope.m.preferredAreas.ne;
			scope.m.zone7 = scope.m.preferredAreas.ar &&
                scope.m.preferredAreas.la &&
                scope.m.preferredAreas.ok &&
                scope.m.preferredAreas.tx;
			scope.m.zone8 = scope.m.preferredAreas.az &&
                scope.m.preferredAreas.co &&
                scope.m.preferredAreas.id &&
                scope.m.preferredAreas.nv &&
                scope.m.preferredAreas.nm &&
                scope.m.preferredAreas.ut &&
                scope.m.preferredAreas.wy;
			scope.m.zone9 = scope.m.preferredAreas.ca &&
                scope.m.preferredAreas.or &&
                scope.m.preferredAreas.wa &&
                scope.m.preferredAreas.ak;


			allUsZonesHelper();
		}

		function allUsZonesHelper() {
			scope.m.allUsZones = scope.m.zone0 &&
                scope.m.zone1 &&
                scope.m.zone2 &&
                scope.m.zone3 &&
                scope.m.zone4 &&
                scope.m.zone5 &&
                scope.m.zone6 &&
                scope.m.zone7 &&
                scope.m.zone8 &&
                scope.m.zone9;
		}

		function savePreferredAreas(callback) {
			if (scope.m.isDirty) {
				var preferredAreas = [];
				for (var key in scope.m.preferredAreas) {
					if (scope.m.preferredAreas[key]) {
						preferredAreas.push(key.toUpperCase());
					}
				}
				carrierRegistrationService
					.updatePreferredAreas(preferredAreas, scope.m.hasServiceInMexico, scope.carrierId)
					.then(function() {
						scope.m.isDirty = false;
						if (!scope.m.showNewLane)
							window.onbeforeunload = undefined;
						if (typeof (callback) === 'function')
							callback();
					});

			} else if (typeof (callback) === 'function')
				callback();
		}

		function goToTab(tab) {
			observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_SET_PENDING_TAB, tab);
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_START_CHANGE_CARRIER_PROFILE_VIEW,
				navigate);
		}

		function setPendingTab(tab) {
			scope.tab = tab;
		}

		function navigate() {
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_FINISH_CHANGE_CARRIER_PROFILE_VIEW,
				scope.tab);
		}
	}

})();
